import { SchemaField } from "@redotech/redo-flows-core-schema-common/type-system/schema";
import { variableDisplayName } from "@redotech/redo-flows-core-schema-common/type-system/variable-display";

const normalize = (value: string) => value.toLowerCase().replace(/[\s_]/g, "");

/**
 * Whether a variable matches the insert-variable modal's search box. Matches
 * documentation too, so a merchant can find a field by what it does.
 */
export function matchesVariableSearch(
  field: SchemaField,
  query: string,
): boolean {
  const normalizedQuery = normalize(query);
  if (!normalizedQuery) {
    return true;
  }
  return normalize(
    `${variableDisplayName(field)} ${field.documentation}`,
  ).includes(normalizedQuery);
}
